import { useMemo } from 'react';
import applicationConstants from '../../../../Core/Utility/ApplicationConstants';
import { Currency } from '../../../../Generated/Raven-Demeter';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import Dropdown from './Dropdown';

type CurrencyDropdownOptionsType = { label: string; value: Currency | undefined };

interface ICurrencyDropdownProps {
    disabled?: boolean;
    currency?: Currency;
    handleChange: (value: Currency | undefined) => void;
    label?: string;
    hideNativeOption?: boolean;
    track: TrackingEvent;
}

const CurrencyDropdown: React.FC<ICurrencyDropdownProps> = (props): JSX.Element => {
    const [translations] = useLanguage();

    const currencyDropdownOptions = useMemo(() => {
        const options = [] as CurrencyDropdownOptionsType[];

        if (!props.hideNativeOption) {
            options.push({
                label: translations.dropdown.nativeCurrency,
                value: undefined,
            } as CurrencyDropdownOptionsType);
        }

        applicationConstants.AvailableCurrencies.forEach((x) => {
            options.push({
                label: translations.currency[x],
                value: x,
            });
        });

        return options;
    }, [translations, props.hideNativeOption]) as CurrencyDropdownOptionsType[];

    return (
        <Dropdown
            disabled={props.disabled ?? false}
            value={props.currency ?? undefined}
            options={currencyDropdownOptions}
            handleOptionChange={(value: Currency | undefined) => props.handleChange(value)}
            label={props.label}
            track={props.track}
        />
    );
};

export default CurrencyDropdown;
